import { useContext } from "react";
import CmsContent from "../cms-content";
import AppError from "../app-error";
import OsteopataContext from "../../context/osteopata";

const OsteopataDetail = ({ data }) => {
  const { labels, infoError } = useContext(OsteopataContext);

  return infoError ? (
    <AppError labels={labels} />
  ) : (
    <div className="wrapper wrapper-small wrapper--coldpage">
      <CmsContent data={data} />
      {/* <div className="form__buttons form__buttons--center">
        <button
          className="button primary form__submit"
          onClick={() => {
            setCurrentRequest("new");
            setNavigation();
          }}
        >
          {labels?.WELFARE_OSTEOPATA_BOOKING_CTA_LONG || "Prenota la tua visista"}
        </button>
      </div> */}
    </div>
  );
};

export default OsteopataDetail;
